export const Logo = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-label="Aetheris Labs logo">
    <path
      d="M16 2.5L28.5 9.75V22.25L16 29.5L3.5 22.25V9.75L16 2.5Z"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <path d="M16 9.5L21.8 21.5H19.4L16 14.4L12.6 21.5H10.2L16 9.5Z" fill="currentColor" />
    <circle cx="16" cy="18.6" r="1.5" fill="#6D28D9" />
  </svg>
);
